<template>
    <div>
        <!-- Modal Body -->
        <div class="modal-body" style="min-height: 500px;">
            <div class="editor-wrapper">
                <ckeditor :editor="editor" v-model="editorContent" :config="editorConfig" />
            </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="save">Salva</button>
        </div>
    </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@/utils/CustomCKEditor';

export default {
    name: 'WordEditor',
    components: {
        ckeditor: CKEditor.component
    },
    props: {
        file: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {},
            editorContent: '',
            currentFont: 'Arial'
        };
    },
    created() {
        this.loadDocx();
    },
    methods: {
        loadDocx() {
            utils.ajax('ftp/convert-docx-to-html', { fullPath: this.file.fullPath }, (response) => {
                if (response.esito == 0) {
                    const parsedData = JSON.parse(response.data);
                    const fullHtml = parsedData.html || '';
                    const match = fullHtml.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
                    this.editorContent = match ? match[1].trim() : fullHtml;
                    this.currentFont = parsedData.font || 'Arial';
                    
                }
            }, true, 0, 'GET');

        },
        sanitizeHtml(html) {
            const div = document.createElement('div');
            div.innerHTML = html;
            ['script', 'style', 'meta', 'title', 'link'].forEach(tag => {
                div.querySelectorAll(tag).forEach(el => el.remove());
            });
            div.querySelectorAll('*').forEach(el => {
                [...el.attributes].forEach(attr => {
                    if (/^on/i.test(attr.name)) el.removeAttribute(attr.name);
                });
            });
            return div.innerHTML.replace(/<!--[\s\S]*?-->/g, '').trim();
        },
        save() {
            const cleanHtml = this.sanitizeHtml(this.editorContent);
            utils.ajax('/ftp/save-word-html', { fullPath: this.file.fullPath, content: cleanHtml, fontName: this.currentFont}, response => {
                if (response.esito == 0) {
                    utils.alert.success('Documento salvato con successo');
                    this.$emit('salvato', {
                        fullPath: this.file.fullPath,
                        status: 'ok',
                        message: response.messaggio || 'Salvato'
                    });
                } else {
                    utils.alert.warning(response.messaggio || 'Errore durante il salvataggio');
                }
            });
        }
    },
    watch: {
        file: {
            immediate: true,
            handler(newFile, oldFile) {
                if (newFile && newFile.fullPath != (oldFile?.fullPath || '')) {
                    this.loadDocx();
                }
            }
        }
    }

};
</script>

<style scoped>
.editor-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem;
}
</style>
